/* Sort only the articles already rendered on this Shopify pagination page. */
(() => {
  const initialise = (root) => {
    if (!(root instanceof Element)) return;
    const selects = root.matches('[data-insights-sort]') ? [root] : root.querySelectorAll('[data-insights-sort]');
    selects.forEach((select) => {
      if (select.dataset.insightsReady) return;
      select.dataset.insightsReady = 'true';
      const section = select.closest('.uf-insights-page');
      const grid = section && section.querySelector('[data-insights-grid]');
      if (!grid) return;
      const original = [...grid.children];
      select.addEventListener('change', () => {
        const cards = [...original];
        if (select.value === 'oldest') {
          cards.sort((a, b) => (a.dataset.date || '').localeCompare(b.dataset.date || ''));
        } else if (select.value === 'title') {
          cards.sort((a, b) => (a.dataset.title || '').localeCompare(b.dataset.title || '', undefined, { sensitivity: 'base' }));
        }
        grid.replaceChildren(...cards);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document.body), { once: true });
  else initialise(document.body);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
